module.exports = __webpack_public_path__ + "static/summer_eladrin-cc3d7c7f325001b051f26e3e4a833a70.png";